// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".w-spinner{animation:spinnerAppearDelayed .3s ease-out 0s both;animation:spinnerAppearDelayed .3s var(--appear-delay,0s) ease-out both;color:var(--color-primary);height:1.3em;width:1.3em}.w-spinner--inverse{color:var(--swi-body-text-color-on-dark)}@keyframes spinnerAppearDelayed{0%{opacity:0}to{opacity:1}}.w-spinner__path{fill:none;stroke:currentColor}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
